import React, {useContext, useState} from 'react';
import './PromocodeEdit.less';
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {Button} from "elements/button/Button";
import {Input} from "elements/input/Input";
import {Error} from 'elements/error/Error';
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const PROMOCODE_EDIT_POPUP = 'PROMOCODE_EDIT_POPUP';

export const PromocodeEdit = ({error, onCancelClick, onDoneClick, onOverlayClick}) => {
	const [promocode, setPromocode] = useState('');

	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		title={getSafeTranslation('PromocodeEditPopup.title', translations)}
		onOverlayClick={onOverlayClick}
		leftControl={<Button isText onClick={onCancelClick}>{
			getSafeTranslation('PromocodeEditPopup.cancelButtonCaption', translations)
		}</Button>}
		rightControl={<Button isText onClick={() => onDoneClick(promocode)}>{
			getSafeTranslation('PromocodeEditPopup.doneButtonCaption', translations)
		}</Button>}
	>
		<div className="promocode-edit">
			<div className="promocode-edit__input">
				<Input value={promocode} onChange={setPromocode} focusOnMount/>
			</div>
			{
				error && (
					<div className="promocode-edit__error">
						<Error text={error}/>
					</div>
				)
			}

		</div>
	</DrawerPopup>
}
